<script setup>

//Emits and props
defineProps({
  imageUrl: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <img
    v-if="imageUrl"
    :src="imageUrl"
    :class="$style.image"
  >
</template>

<style module lang="scss">
.image {
  display: block;
  max-height: 350px;
  margin: 0 auto;
  object-fit: cover;
  border-radius: var(--border-radius-m);
  @media (min-width: 768px) {
    margin: 1.5rem 0 2rem;
  }
}
</style>
